/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SearchProfileResponseDto } from '../models/SearchProfileResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SearchProfileService {

    /**
     * @param sessionId
     * @param formData
     * @returns boolean Success
     * @throws ApiError
     */
    public static searchProfileSaveSearchProfile(
        sessionId?: string,
        formData?: {
            ContactId?: string;
            ProfileId?: string;
            PUL?: boolean;
            SelectedChargeMax?: string;
            SelectedChargeMin?: string;
            SelectedLivingspaceMax?: string;
            SelectedLivingspaceMin?: string;
            SelectedPriceMax?: string;
            SelectedPriceMin?: string;
            SelectedRoomMax?: string;
            SelectedRoomMin?: string;
            SelectedPlotMax?: string;
            SelectedPlotMin?: string;
            Alignment?: string;
            SelectedMunicips?: Array<string>;
            SelectedAreas?: Array<string>;
            SelectedDrawnAreas?: string;
            SearchProfileName?: string;
            Email?: string;
            SelectedEstateType?: Array<string>;
            SelectedExtraCrits?: Array<string>;
            Firstname?: string;
            Lastname?: string;
            ZipCode?: string;
            Address?: string;
            City?: string;
            PhoneCell?: string;
            OfficeList?: string;
        },
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/SearchProfile/SaveSearchProfile',
            query: {
                'sessionId': sessionId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param sessionId
     * @param profileId
     * @returns SearchProfileResponseDto Success
     * @throws ApiError
     */
    public static searchProfileGetSearchProfile(
        sessionId?: string,
        profileId?: string,
    ): CancelablePromise<SearchProfileResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/SearchProfile/SearchProfile',
            query: {
                'sessionId': sessionId,
                'profileId': profileId,
            },
        });
    }

    /**
     * @param sessionId
     * @param profileId
     * @returns any Success
     * @throws ApiError
     */
    public static searchProfileDeleteSearchProfile(
        sessionId?: string,
        profileId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/SearchProfile/SearchProfile',
            query: {
                'sessionId': sessionId,
                'profileId': profileId,
            },
        });
    }

}
